import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IOfferDiscoverParams } from "../../../Orchestrator/Types/Interface/ICMSOffers";

class OffersDicoverClickAction extends BaseAction<void, IOfferDiscoverParams> {
    override async run(): Promise<void> {
        const { slug } = this.params!;
        _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/offers/${slug}`,
        })
    }
}

export const offersDicoverClickAction = new OffersDicoverClickAction();
